import { SvgIcon } from "@mui/material"

import { ReactComponent as Pin } from "./pin.svg"

export const PinIcon = (props) => {
    return (
        <SvgIcon component={Pin} {...props} inheritViewBox />
    )
}